import React, { useContext, createContext, useState } from 'react';
const Context = createContext({});
export default function OptionsProvider({ children, ...props }) {
    const state = useState([]);
    return <Context.Provider value={state}>{children}</Context.Provider>;
}

export function useOptions() {
    const value = useContext(Context);

    return value;
}
